// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2VMRb","alertIcon":"ConfirmModal_alertIcon__3b0mN"};